import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import RecipeList from '../components/RecipeList';
import { Link } from 'react-router-dom';
import { CgAdd, CgBowl } from "react-icons/cg";

function RecipesPage({ setRecipe }) {
    // Use the Navigate for redirection
    const redirect = useNavigate();

    // Use state to bring in the data
    const [recipes, setRecipes] = useState([]);

    // RETRIEVE the entire list of recipes
    const loadRecipes = async () => {
        const response = await fetch('/recipes');
        const recipes = await response.json();
        setRecipes(recipes);
    } 
    

    // UPDATE a single recipe
    const onEditRecipe = async recipe => {
        setRecipe(recipe);
        redirect("/EditRecipePageTable");
    }


    // DELETE a single recipe 
    const onDeleteRecipe = async _id => {
        const response = await fetch(`/recipes/${_id}`, { method: 'DELETE' });
        if (response.status === 200) {
            const getResponse = await fetch('/recipes');
            const recipes = await getResponse.json();
            setRecipes(recipes);
        } else {
            console.error(`There was a problem or ${_id} doesn't exist. Entry not deleted. Status code = ${response.status}`)
        }
    }

    // LOAD all the recipes
    useEffect(() => {
        loadRecipes();
    }, []);

    // DISPLAY the recipes
    return (
        <>
            <h2>List of Recipes</h2>
            <p>My wife Christine is a great cook and has amassed quite a pile of recipes over the years—modified to her liking of course. 
                I thought her creations were deserving of an archive, and this collection is a tribute to her art.</p>
            <Link to="/AddRecipePageTable"><CgAdd size='30'/><CgBowl size='30' /></Link>
            <RecipeList 
                recipes={recipes} 
                onEdit={onEditRecipe} 
                onDelete={onDeleteRecipe} 
            />
        </>
    );
}

export default RecipesPage;